import { isEmpty } from '../utils/utils';
import {config} from './config';
import Cookies from 'js-cookie';

type fetchType = {
  method?: string;
  body?: any;
  query?: any;
  headers?: {
    'content-type'?: string;
    accessToken?: string;
    refreshToken?: string;
    Authorization?: any;
  };
};

const api = async (url: string, request: fetchType = {}, useToken = false) => {
  const baseUrl = config.baseUrl;
  const headers: any = request.headers || {};
  if (request.method?.toUpperCase() == 'GET') {
    headers['Cache-Control'] = 'no-cache';
  }
  if (isEmpty(headers)) {
    headers['content-type'] = 'application/json';
  }
  // Always attach: a GET adds Cache-Control first, and skipping this left the
  // Authorization header off the request (e.g. /worker/user/rating -> 401)
  request = {...request, headers};

  if (useToken) headers.Authorization = `Bearer ${Cookies.get('worker-token')}`;

  if (headers['content-type'] === 'application/json' && request.body) {
    request.body = JSON.stringify(request.body);
  }

  return await fetch(baseUrl + url, request)
    .then(async (response: any) => {
      return await response.json();
    })
    .catch((error) => {
      console.log('Fetch error', error);
      return {};
    });
};

export { api };
